import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from '@ag-grid-community/angular';


@Component({
  selector: 'app-router-link-cell-renderer',
  template: `<div stype="display: inline-block; text-align: center;"><a routerLink="/uw/acord/{{params.value}}">
               <fa-icon *ngIf="params.data.losshistory" style="color: limegreen" [icon]="['fas', 'plus-square']"></fa-icon>
               <fa-icon *ngIf="!params.data.losshistory"  style="color: orangered" [icon]="['fas', 'minus-square']"></fa-icon>
             </a></div>`
})
export class RouterLinkCellRendererComponent implements ICellRendererAngularComp {

    public params: any;

    constructor() { }

    agInit(params: any): void {
      this.params = params;
    }
    refresh(): boolean {
        return false;
    }
}

